import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';
import {App} from "./app";
import {Layout} from "./views/Admin/Layout/Layout";
import StatisticMember from "./components/StatisticMember";
import {store} from "@/store/store";
import {Provider} from "react-redux";
import SettingsEvents from "./views/Admin/Events/Event/Registration/SettingsEvents";
import Form from "./views/Admin/Events/Event/Registration/Form/Form";
import PaymentMethods from "./views/Admin/Events/Event/Registration/PaymentMethods/PaymentMethods";
import SettingsButtons from "./views/Admin/Events/Event/Registration/SettingsButtons/SettingsButtons";
import SettingsPdfTicket from "./views/Admin/Events/Event/Registration/PdfTicket/SettingsPdfTicket";
import Theme from "@/views/Admin/Events/Event/Registration/Theme/Theme";
import Notifications from "./views/Admin/Events/Event/Notifications/Notifications";
import RegistrationSettings from "./components/RegistrationSettings";
import PublishEvent from "./views/Admin/Events/PublishEvent/PublishEvent";
import MemberCharts from "./views/Admin/Courses/Course/Lessons/Statistic/Charts/MemberCharts"
import renderReactComponent from "@/utils/renderReactComponent";
import General from "@/views/Admin/Events/Event/General/General";
import {ToastProvider} from "uikit";
import Member from "@/views/Admin/Statistic/Member/Member";
import Promocodes from "@/views/Admin/Events/Event/Promocodes/Promocodes";
import Tariffs from "@/views/Promo/Prices/Tariffs/Tariffs";

window.hostClient = document.getElementById('App')?.getAttribute('data-api-host');

renderReactComponent('Layout', Layout, '*')

document.addEventListener("DOMContentLoaded", () => {
    const appElement = document.getElementById('App');

    if (appElement) {
        const root = createRoot(appElement);
        root.render(
            <Provider store={store}>
                <Router>
                    <ToastProvider>
                        <App/>
                    </ToastProvider>
                </Router>
            </Provider>
        );
    }

    /* Панель управления -> Шапка */
    renderReactComponent('react-section-settings-general', General, ['/admin/courses/:id/promo/', '/admin/settings/:id/', '/admin/events/:id/:tab', '/admin/statistic/:id', '/admin/:tab/settings/:id/'])

    /*Промо страницы*/
    renderReactComponent('react-section-tariffs', Tariffs, '/prices/')

    /* Панель управления -> Регистрация и билеты */
    renderReactComponent('react-section-tickets', SettingsEvents, '/admin/events/:id/form')
    renderReactComponent('react-section-settings-pdf', SettingsPdfTicket, '/admin/events/:id/form')
    renderReactComponent('react-section-settings-order', RegistrationSettings, '/admin/events/:id/form')
    renderReactComponent('react-section-fields', Form, '/admin/:type_event_id/:id/form')
    renderReactComponent('react-section-theme', Theme, '/admin/:type_event_id/:id/form')
    renderReactComponent('react-section-payment-methods', PaymentMethods, '/admin/:type_event_id/:id/form')
    renderReactComponent('react-section-settings-buttons', SettingsButtons, '/admin/:type_event_id/:id/form')

    /* Панель управления -> Уведомления */
    renderReactComponent('react-section-notifications-tab', Notifications, '/admin/:type/:event_id/notifications')

    /* Панель управления -> Промокоды */
    renderReactComponent('react-section-promocodes', Promocodes, '/admin/:type/:event_id/promo')

    /* Настройка события -> Кнопка публикации */
    renderReactComponent('react-button-publish', PublishEvent, '/admin/:type/:event_id/:tab')
    renderReactComponent('react-button-publish', PublishEvent, '/admin/:type/:event_id/')
    renderReactComponent('react-section-charts-tab', MemberCharts, '/admin/course/:eventId/statistic/charts')

    /*Страница одного заказа -> Редактор поля Субъекта РФ*/
    let regionData = document.getElementsByClassName("region-field-suggest")
    if (regionData.length) {
        for (const field of regionData) {
            let id = field.getAttribute('data-id')
            renderReactComponent(`region-field-suggest-${id}`, () => Member(id), ['/admin/statistic/:id/order/:id/', '/admin/course/:id/statistic/:id/'])
        }
    }


    let collectionMember = document.getElementsByClassName("StatisticScheduleMember")
    if (collectionMember.length) {
        for (const member of collectionMember) {
            let orderTicket = member.getAttribute('data-order-ticket-id')
            const idElMember = `memberTicket-${orderTicket}`
            renderReactComponent(idElMember, () => StatisticMember(orderTicket), '/admin/statistic/:id/order/:id/')
        }
    }
});
